import { dataFrowningFaceSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFrowningFaceSolid = /*#__PURE__*/createIcon(dataFrowningFaceSolid)
export default IconFrowningFaceSolid
